import { useTranslations } from 'next-intl';

import type { JSX } from 'react';

import { formatAddress } from '~/utils';
import { MapPinIcon } from '~/components/icons';
import { IconLabel } from '~/components/icon-label';

import type { serviceLocations } from '~/constants';
import type { ILocationVM, TObjectValueType } from '~/types';

interface ILocationLabelProps {
  className?: string;
  iconClassName?: string;
  location?: ILocationVM;
  type?: TObjectValueType<typeof serviceLocations>;
}

export function LocationLabel({
  type,
  location,
  className,
  iconClassName,
}: ILocationLabelProps): JSX.Element {
  const t = useTranslations();

  return (
    <IconLabel
      icon={MapPinIcon}
      className={className}
      iconClassName={iconClassName}
      text={
        type === 'remote'
          ? t('enums.serviceLocation.remote')
          : formatAddress(location)
      }
    />
  );
}
